import { render } from "./CreditNotes.vue?vue&type=template&id=133507b1"
import script from "./CreditNotes.vue?vue&type=script&lang=js"
export * from "./CreditNotes.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/cradle.staging.moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__